import React from 'react';
import logo from '../assets/logo.png';

const DeviceVerification = ({ isVerified = false }) => {
  return (
    <div
      id="device-verification-screen"
      className="min-h-screen w-full bg-white flex flex-col items-center justify-center px-4 select-none"
    >
      <div className="flex flex-col items-center text-center max-w-md mx-auto">
        {/* RS Red Square Logo */}
        <div className="mb-8">
          <img
            src={logo}
            alt="RS"
            className="w-28 h-28 object-contain rounded-md shadow-sm"
          />
        </div>

        {/* Verification Headline */}
        <h1 className="text-2xl sm:text-[26px] font-normal text-[#1A1A1A] tracking-tight mb-8">
          Verifying the device...
        </h1>

        {/* Dynamic Status: Blue pulsating/spinner dot OR Green checkmark */}
        <div className="h-14 flex items-center justify-center mb-8">
          {!isVerified ? (
            <div className="flex items-center justify-center">
              <span className="relative flex h-5 w-5">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#38bdf8] opacity-75"></span>
                <span className="relative inline-flex rounded-full h-5 w-5 bg-[#38bdf8]"></span>
              </span>
            </div>
          ) : (
            <div className="w-12 h-12 rounded-full border-[1.5px] border-[#16a34a] flex items-center justify-center animate-scale-in">
              <svg
                className="w-6 h-6 text-[#16a34a]"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
          )}
        </div>

        {/* Disclaimer / Notice text */}
        <p className="text-sm text-[#333333] font-normal">
          The requested content will be available after verification.
        </p>
      </div>
    </div>
  );
};

export default DeviceVerification;
